import React from "react";

function StartTestIcon() {
  return (
    <svg
      width={33}
      height={33}
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="navIcon noStroke"
    >
      <path
        d="M17.779 17.765a2.579 2.579 0 01-2.577 2.575 2.578 2.578 0 01-2.577-2.575c0-.951.52-1.783 1.289-2.228V8.432h2.576v7.105a2.575 2.575 0 011.289 2.228zM33 24.91L19.775 33V16.819L33 24.909zm-10.648 3.495l5.713-3.495-5.713-3.496v6.99zM2.577 17.765c0-6.956 5.663-12.616 12.625-12.616s12.625 5.66 12.625 12.616c0 .316-.012.63-.035.94l2.42 1.48c.127-.793.192-1.601.192-2.42a15.085 15.085 0 00-4.78-11.059l1.067-1.279 1.749 1.458 1.65-1.977L24.613.344l-1.65 1.977 1.749 1.458-1.105 1.323A15.06 15.06 0 0016.49 2.63V0h-2.576v2.63a15.092 15.092 0 00-9.462 4.394A15.085 15.085 0 000 17.764c0 4.058 1.581 7.873 4.453 10.742a15.108 15.108 0 0010.749 4.45c.673 0 1.34-.045 1.997-.13v-2.604c-.65.104-1.318.159-1.997.159-6.962 0-12.625-5.66-12.625-12.616z"
        fill="#412A7C"
      />
    </svg>
  );
}

export default StartTestIcon;
